export const environment = {
  name: "Dev",
  production: false,
  baseURL: "https://sasbusimt-api-dev.azure.chevron.com",
  UIbaseURL: "https://sasbusimt-dev.azure.chevron.com",
  clientId: "9ca3ed02-c615-4ee5-bb8e-6bd340e7b487",
  tenantId: "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
  lookbackDowloadPPTFileForEdit: "",
  lookbackCopyBackToBlobStorage: "",
  endpointScopes: ['9ca3ed02-c615-4ee5-bb8e-6bd340e7b487/.default'],
  appInsights: {
    instrumentationKey: "a4835e81-4b55-4680-addf-0026753199ab"
}
};
